<template>
  <div class="helpcenter-section-view__wrapper">
    <NavBar class="helpcenter-section-view__nav">
      <template #left>
        <span>
          <BackButton />
        </span>
      </template>

      <template #center>
        <span v-if="!isLoading">{{ section.name }}</span>
      </template>
    </NavBar>
    <div
      class="helpcenter-section-view__content"
      :class="{
        'helpcenter-section-view__content--impersonate': isImpersonate
      }"
    >
      <SkeletonLoader
        v-if="isLoading"
        class="helpcenter-section-view__content__loader"
        data-testid="loader"
      >
        <div v-for="index in 5" :key="index" class="row-loader" />
      </SkeletonLoader>
      <div v-else>
        <Row
          v-for="(article, index) in section.articles"
          :key="index"
          :has-interaction="true"
          :chevron="true"
          :left-title="article.title"
          :has-line="false"
          @click="openArticle(article)"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader, Row } from '@warrenbrasil/nebraska-web';
import { NavBar } from '@/modules/common/components/__deprecated__/NavBar';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import {
  getSection,
  IHelpCenterArticle,
  IHelpCenterSection
} from '@/modules/help-center/services/help-center';
import { isImpersonate } from '@/modules/common/services/partner';

@Component({
  components: {
    SkeletonLoader,
    BackButton,
    NavBar,
    Row
  }
})
export default class HelpCenterSectionView extends Vue {
  isLoading = true;
  isImpersonate = false;
  section: IHelpCenterSection | null = null;

  private async mounted() {
    this.isImpersonate = isImpersonate();

    const { section } = await getSection(this.$route.params.id);
    this.section = section;
    this.isLoading = false;
  }

  openArticle(article: IHelpCenterArticle) {
    this.$router.push({
      name: 'help-center-article',
      params: { articleId: String(article.id) }
    });
  }
}
</script>

<style lang="less" scoped>
@height-navbar: 64px;

.helpcenter-section-view__wrapper {
  .helpcenter-section-view__nav {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 20;
    border-bottom: 1px solid @divider-primary;
    background: @background-secondary !important;
    * > {
      color: @text-primary !important;
    }
  }
  .helpcenter-section-view__content {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    min-height: calc(100vh - @height-navbar);
    margin: 0px auto;
    padding: @size-spacing-x1100 @size-spacing-x400 0px;

    &.helpcenter-section-view__content--impersonate {
      padding: calc(@spacing-xxl + @size-spacing-x300) @size-spacing-x400 0px;
    }
  }
}
.helpcenter-section-view__content__loader {
  padding-top: @size-spacing-x800;
  .row-loader {
    height: 30px;
    margin: @size-spacing-x500 0;
    border-radius: 10px;
  }
}
</style>
